module.exports = __webpack_public_path__ + "img/img9.fb723f47.svg";